import INVENTORY_API_BASE_URL from "../../config/api";
import "../SuperDistributor/superdistributor.css";
import { useState, useRef } from "react";
import Axios from "axios";
import swal from "sweetalert";

function Createsuperdistributor() {
  const [dname, setdname] = useState("");
  const [pname, setpname] = useState("");
  const [mobno, setmobno] = useState("");
  const [amobno, setamobno] = useState("");
  const [whatsappno, setwhatsappno] = useState("");
  const [email, setemail] = useState("");
  const [billingaddress, setbillingaddress] = useState("");
  const [shippingaddress, setshippingaddress] = useState("");
  const [discount, setdiscount] = useState("");
  const [gst, setgst] = useState("");
  const [pancard, setpancard] = useState("");
  const [aadhar, setaadhar] = useState("");
  const [img6, setimg6] = useState();
  const [img7, setimg7] = useState();
  const [img8, setimg8] = useState();

  const [isChecked, setIsChecked] = useState(false);

  const firstInputRef = useRef(null);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };



  const handleSubmit = (event) => {
    event.preventDefault();
    if (!dname) {
      swal({
        title: "Error",
        text: "Please enter the Super Distributor Name.",
        icon: "error",
      });
      return;
    }

    const formData = new FormData();
    formData.append("dname", dname);
    formData.append("pname", pname);
    formData.append("mobno", mobno);
    formData.append("amobno", amobno);
    formData.append("whatsappno", whatsappno);
    formData.append("email", email);
    formData.append("billingaddress", billingaddress);
    formData.append("shippingaddress", shippingaddress);
    formData.append("discount", discount);
    formData.append("aadhar", aadhar);
    formData.append("gst", gst);
    formData.append("pancard", pancard);
    formData.append("img6", img6);
    formData.append("img7", img7);
    formData.append("img8", img8);

    Axios.post(
      `${INVENTORY_API_BASE_URL}/postCreatesuperdistributor`,
      formData
    )
      .then((response) => {
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
      });
    swal({
      title: "Super Distributor Created",
      text: "",
      icon: "success",
    });
    window.location.reload(false);
    if (firstInputRef.current) {
      firstInputRef.current.focus();
    }
  };

  return (
    <main className="distcreate-container">
      <div className="superdist-create-content">
        <header className="superdist-create-heading">
          <div>
            <p className="superdist-eyebrow">Partner network</p>
            <h1>Create a super distributor</h1>
            <p>Set up a partner profile, add contact details, and attach the required documents.</p>
          </div>
          <span className="superdist-create-badge">
            <span aria-hidden="true" />
            New partner
          </span>
        </header>

        <section className="superdist-form-card" aria-labelledby="superdist-details-title">
          <div className="superdist-form-section-heading">
            <span className="superdist-form-step" aria-hidden="true">01</span>
            <div>
              <h2 id="superdist-details-title">Business and contact details</h2>
              <p>Enter the distributor’s business information and primary contacts.</p>
            </div>
          </div>

          <div className="superdist-fields-grid">
            <label className="superdist-field superdist-field--wide">
              <span>Super distributor name <b aria-hidden="true">*</b></span>
              <input
                ref={firstInputRef}
                type="text"
                name="dname"
                value={dname}
                required="required"
                onChange={(event) => {
                  setdname(event.target.value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>Contact person name</span>
              <input
                type="text"
                name="pname"
                value={pname}
                onChange={(event) => {
                  setpname(event.target.value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>Mobile number</span>
              <input
                type="text"
                name="mobno"
                value={mobno}
                maxLength={10}
                onChange={(event) => {
                  const value = event.target.value.replace(/[^0-9]/g, "");
                  setmobno(value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>Alternate mobile number</span>
              <input
                type="text"
                name="amobno"
                value={amobno}
                maxLength={10}
                onChange={(event) => {
                  const value = event.target.value.replace(/[^0-9]/g, "");
                  setamobno(value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>WhatsApp number</span>
              <input
                type="text"
                name="whatsappno"
                value={whatsappno}
                maxLength={10}
                onChange={(event) => {
                  const value = event.target.value.replace(/[^0-9]/g, "");
                  setwhatsappno(value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>Email address</span>
              <input
                type="text"
                name="email"
                value={email}
                onChange={(event) => {
                  setemail(event.target.value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>Discount (%age)</span>
              <input
                type="text"
                name="discount"
                value={discount}
                maxLength={3}
                onChange={(event) => {
                  let value = event.target.value.replace(/[^0-9]/g, "");
                  if (parseInt(value) > 100) value = "100";
                  setdiscount(value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>Aadhaar number</span>
              <input
                type="text"
                name="aadhar"
                value={aadhar}
                maxLength={12}
                onChange={(event) => {
                  const value = event.target.value.replace(/[^0-9]/g, "");
                  setaadhar(value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>GST number</span>
              <input
                type="text"
                name="gst"
                value={gst}
                onChange={(event) => {
                  setgst(event.target.value);
                }}
              />
            </label>

            <label className="superdist-field">
              <span>PAN card number</span>
              <input
                type="text"
                name="pancard"
                value={pancard}
                onChange={(event) => {
                  setpancard(event.target.value);
                }}
              />
            </label>

            <label className="superdist-field superdist-field--wide">
              <span>Billing address</span>
              <textarea
                name="billingaddress"
                rows={3}
                value={billingaddress}
                onChange={(event) => {
                  setbillingaddress(event.target.value);
                }}
              />
            </label>

            <label className="superdist-field superdist-field--wide">
              <span>Shipping address</span>
              <textarea
                name="shippingaddress"
                rows={3}
                value={shippingaddress}
                onChange={(event) => {
                  setshippingaddress(event.target.value);
                }}
              />
            </label>
          </div>
        </section>

        <section className="superdist-form-card" aria-labelledby="superdist-documents-title">
          <div className="superdist-form-section-heading">
            <span className="superdist-form-step" aria-hidden="true">02</span>
            <div>
              <h2 id="superdist-documents-title">Supporting documents</h2>
              <p>Attach the documents associated with this distributor profile.</p>
            </div>
          </div>

          <div className="superdist-upload-grid">
            <label className="superdist-upload-field">
              <span className="superdist-upload-icon" aria-hidden="true">↑</span>
              <span className="superdist-upload-copy">
                <strong>PAN card upload</strong>
                <small>Select a PAN card file</small>
              </span>
              <input
                type="file"
                onChange={(e) => {
                  setimg6(e.target.files[0]);
                }}
              />
            </label>

            <label className="superdist-upload-field">
              <span className="superdist-upload-icon" aria-hidden="true">↑</span>
              <span className="superdist-upload-copy">
                <strong>Aadhaar card upload</strong>
                <small>Select an Aadhaar card file</small>
              </span>
              <input
                type="file"
                onChange={(e) => {
                  setimg7(e.target.files[0]);
                }}
              />
            </label>

            <label className="superdist-upload-field">
              <span className="superdist-upload-icon" aria-hidden="true">↑</span>
              <span className="superdist-upload-copy">
                <strong>Signature upload</strong>
                <small>Select a signature file</small>
              </span>
              <input
                type="file"
                onChange={(e) => {
                  setimg8(e.target.files[0]);
                }}
              />
            </label>
          </div>
        </section>

        <section className="superdist-terms-card" aria-labelledby="superdist-terms-title">
          <div className="superdist-form-section-heading">
            <span className="superdist-form-step" aria-hidden="true">03</span>
            <div>
              <h2 id="superdist-terms-title">Terms and conditions</h2>
              <p>Review and accept the partner terms before saving.</p>
            </div>
          </div>

          <ol className="superdist-terms-list">
            <li>Super distributor will not sell to any retailer, distributor, wholesaler or self who are selling on Amazon and FlipKart.</li>
            <li>Pinnacle does not allow anybody to sell pinnacle books on Amazon and Flipkart.</li>
            <li>Super distributor will keep optimum stock recommended by Pinnacle publications of all books.</li>
            <li>Super distributor will not spoil market by providing any extra discount by any mean to create unfair competition.</li>
            <li>Pinnacle publications will decide discount rules, geography, payment flow, return policy, stock keeping rules time to time. Every super distributor, distributor, retailer is bound to follow Pinnacle publications guidelines.</li>
          </ol>

          <label className="superdist-accept-terms">
            <input
              type="checkbox"
              checked={isChecked}
              onChange={handleCheckboxChange}
            />
            <span>I accept all terms and conditions mentioned above.</span>
          </label>

          <div className="superdist-save-row">
            <p>Fields marked with <b aria-hidden="true">*</b> are required.</p>
            <button
              type="submit"
              className="superdist-save-button"
              onClick={handleSubmit}
              disabled={!isChecked}
            >
              Save distributor
              <span aria-hidden="true">→</span>
            </button>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Createsuperdistributor;
